import emailTemplateDefaults from "./emailTemplateDefaults.ar.json";
import {
  EMAIL_TEMPLATE_TABS,
  getAllFieldNames,
} from "./emailTemplateFieldsConfig";

export const GLOBAL_VARIABLES = [
  { key: "{email}", label: "Customer email" },
  { key: "{invoice_no}", label: "Order invoice number" },
  { key: "{site_title}", label: "Site title" },
  { key: "{site_url}", label: "Site URL" },
  { key: "{current_date}", label: "Current date" },
  { key: "{current_time}", label: "Current time" },
  { key: "{current_datetime}", label: "Current date & time" },
];

export const EMAIL_TEMPLATE_OPTION_NAMES = getAllFieldNames().join(",");

export const EMAIL_TEMPLATE_UPLOAD_KEYS = "invoice_logo";

export const EMAIL_TEMPLATE_DEFAULTS = emailTemplateDefaults;

export function getPreviewSampleVariables() {
  const now = new Date();
  return {
    "{email}": "customer@example.com",
    "{invoice_no}": "INV-1001",
    "{site_title}": "My Store",
    "{site_url}": "https://example.com",
    "{current_date}": now.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    }),
    "{current_time}": now.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
    }),
    "{current_datetime}": now.toLocaleString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    }),
  };
}

export function replacePreviewVariables(text) {
  if (!text || typeof text !== "string") return "";
  const samples = getPreviewSampleVariables();
  let result = text;
  Object.entries(samples).forEach(([key, value]) => {
    result = result.split(key).join(value);
  });
  return result;
}

export function buildSavePayload(formData) {
  const payload = {};
  getAllFieldNames().forEach((name) => {
    if (formData[name] !== undefined && formData[name] !== null) {
      payload[name] = formData[name];
    }
  });
  return payload;
}

export function hasDefaultForField(fieldName) {
  return EMAIL_TEMPLATE_DEFAULTS[fieldName] !== undefined;
}

export function getDefaultForField(fieldName) {
  return EMAIL_TEMPLATE_DEFAULTS[fieldName];
}

export function getDefaultsForFieldNames(fieldNames) {
  const defaults = {};
  fieldNames.forEach((name) => {
    if (EMAIL_TEMPLATE_DEFAULTS[name] !== undefined) {
      defaults[name] = EMAIL_TEMPLATE_DEFAULTS[name];
    }
  });
  return defaults;
}

export function subsectionHasDefaults(section) {
  return section.fields.some((field) => hasDefaultForField(field.name));
}

export function getTabById(tabId) {
  return EMAIL_TEMPLATE_TABS.find((tab) => tab.id === tabId);
}

export function getOptionValue(data, key) {
  const value = data?.[key];
  if (value == null) return undefined;
  if (typeof value === "object" && value?.id != null) return value.id;
  return typeof value === "string" || typeof value === "number" ? value : undefined;
}

export function getOptionForMedia(data, key) {
  const value = data?.[key];
  if (!value || typeof value !== "object" || !value.id) return [];
  return [{ id: value.id, path: value.path, type: value.type }];
}
